import React, { useEffect } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";
import Hosted from "../hosted";
import Liked from "../liked";
import Applications from "../applications";
import { useTheme } from "../../../../../context/themeContext";
import { useSelector } from "react-redux";
import { redirect, useLocation, useNavigate } from "react-router-dom";
import useLocalStorageState from "../../../../../hooks/useLocalStorageState";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ paddingTop: "1rem" }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const { theme, darkMode } = useTheme();
  const {
    data: { hostedProjects, applications, likedProjects },
  } = useSelector((state) => state.manageProjects);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [sectionTab, setSectionTab] = useLocalStorageState("section-tab", 0);
  const projectsTabNames = ["hosted", "applications", "liked"];
  const [profileBar, setProfileBar] = useLocalStorageState("myprofile-bar", 0);
  const [redirectUrl, setRedirectUrl] = useLocalStorageState(
    "redirectUrl",
    null
  );

  useEffect(() => {
    setProfileBar(2);
    setRedirectUrl(pathname);
    if (!sectionTab || sectionTab === -1) setSectionTab(0);
  }, []);

  useEffect(() => {
    const currentTab = projectsTabNames.indexOf(pathname.split("/").pop());
    if (currentTab !== -1 && currentTab !== sectionTab) {
      setSectionTab(currentTab);
    }
  }, [pathname]);

  const handleChange = (event, newValue) => {
    setSectionTab(newValue);
    navigate(`/profile/projects/${projectsTabNames[newValue]}`);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={sectionTab === -1 ? 0 : sectionTab}
          onChange={handleChange}
          aria-label="basic tabs example"
          centered
          sx={{
            "& .MuiTab-root": {
              color: darkMode && theme.palette.darkgrey.darkgrey400,
              textTransform: "capitalize",
              "&.Mui-selected": {
                color: darkMode && theme.palette.darkgrey.darkgrey500,
              },
            },
          }}
        >
          <Tab
            sx={{ textTransform: "capitalize" }}
            label={`Hosted(${hostedProjects?.length || 0})`}
            {...a11yProps(0)}
          />
          <Tab
            sx={{ textTransform: "capitalize" }}
            label={`Applications(${applications?.length || 0})`}
            {...a11yProps(1)}
          />
          <Tab
            sx={{ textTransform: "capitalize" }}
            label={`Liked(${likedProjects?.length || 0})`}
            {...a11yProps(2)}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={sectionTab} index={0}>
        <Hosted />
      </CustomTabPanel>
      <CustomTabPanel value={sectionTab} index={1}>
        <Applications />
      </CustomTabPanel>
      <CustomTabPanel value={sectionTab} index={2}>
        <Liked />
      </CustomTabPanel>
    </Box>
  );
}
